import { Auth0Provider } from "@auth0/auth0-react";

export default function Auth0ProviderWithHistory({ children }: any) {
  const onRedirectCallback = (appState: any) => {
    const path = appState?.targetUrl || window.location.pathname;
    window.history.replaceState(
      {},
      document.title,
      `${window.location.origin}#${path}`
    );
  };

  return (
    <Auth0Provider
      cacheLocation="localstorage"
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID ?? ""}
      domain={process.env.REACT_APP_AUTH0_DOMAIN ?? ""}
      onRedirectCallback={onRedirectCallback}
      redirectUri={window.location.origin}
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
}
